import { useState } from "react";
import { assetUrl } from "fusion-core";
import { useNavigate } from "fusion-plugin-react-router";
import { TAXI_QUOTE_BRANDREF } from "../../../../config/config";
import useBuyStore from "../../../buy/store/BuyStore";
import useQuoteStore from "../../store/QuoteStore";
import { getSchemeImage } from "../../../../shared/utils/schemeImages";
import useAppStateStore from "../../../../shared/store/AppStateStore";

const TqPanelCard = ({
  key,
  currentStep,
  companyLogo,
  companyName,
  pricePerYear,
  paymentOptions,
  panelMemberQuoteFeatures,
  panelQuoteData,
  register,
  errors,
  watch,
  setValue,
  isSelected,
  onClick,
  schemeId,
  onOpen,
  featuresModal,
  schemeTableId,
  setSelectedSchemeTableId,
  openExplanationModal,
  quote,
  setSelectedCardIndex, // <-- receive as prop
  setSelectedCard, // <-- use this instead of setSelectedCardQuote
  STATE,
}) => {
  const { setObject } = useBuyStore();
  const navigate = useNavigate();
  const buyStore = useBuyStore.getState();
  const Group = assetUrl("../../../../assets/icons/Group.svg");
  const infoIcon = assetUrl("../../../../assets/icons/info-icon.svg");
  const included_tick = assetUrl("../../../../assets/icons/accordion-tick.svg");
  const star = assetUrl("../../../../assets/icons/excessStar.svg");
  // const data = getValues();
  const brandRef = TAXI_QUOTE_BRANDREF;
  const sabreSchemes = [1729, 1763];
  const [isOpen, setIsOpen] = useState({ featuresModal });
  const [triggerRender, setTriggerRender] = useState(0);

  const hasExcessReductions =
    sabreSchemes.includes(quote.schemeTableId) &&
    quote.panelMemberPanelItems.some(
      (item) => item.panelMemberPanelItemCode === "ER"
    );
  const excessReductionDetails = hasExcessReductions
    ? quote.panelMemberPanelItems.find(
        (item) => item.panelMemberPanelItemCode === "ER"
      )
    : null;

  const isSabreScheme = sabreSchemes.includes(quote.schemeTableId);

  const riskObjectId = useQuoteStore.getState().quote?.risk?.riskObjectId;

  const handleBuyClick = (e) => {
    const index = key;
    setSelectedCardIndex(index);
    setSelectedCard(quote);
    setValue("isSelected", index);
    setValue("companyName", quote.companyName);
    setValue("pricePerYear", quote.pricePerYear);
    setValue("SelectedSchemeTableId", quote.schemeTableId);
    setSelectedSchemeTableId && setSelectedSchemeTableId(schemeTableId);
    onClick();

    // Create the request body
    const panelMemberReqBody = {
      RiskObjectId: riskObjectId,
      RiskObjectHistoryId: "1",
      BrandRef: brandRef,
      PreSelectedQuoteAddons: [],
      SelectedSchemeTableId: quote.schemeTableId || "",
      UseSessionData: true,
    };

    const documentsRequestBody = {
      brandRef,
      RiskObjectId: riskObjectId,
      RiskObjectHistoryId: 1,
      documentTagStage: "Quote",
      documentTagCategory: "PreSaleQuoteDocuments",
    };

    // Store it in BuyStore
    setObject("recommendationsData", null);
    setObject("panelMemberReqBody", panelMemberReqBody);
    setObject("documentsRequestBody", documentsRequestBody);
    setValue("panelMemberReqBody", panelMemberReqBody);

    if (!STATE.memberRetry) {
      STATE.setIspolicyModal(true);
    }

    if (STATE.memberRetry) {
      STATE.setActionOnTqPanel("QuoteSelected");
    }

    if (errors.companyName) {
      trigger("companyName");
    }
  };

  const handleMoreInfoClick = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <div>
      {isSabreScheme && excessReductionDetails && (
        <div className="excessDivCard">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <img src={star} alt="" />
            <b>Excess Reduction: </b>
          </div>
          <div>
            {excessReductionDetails.panelMemberPanelItemLines.map(
              (line, lineIndex) => (
                <>
                  <span key={`line-${lineIndex}`} className="reductionItem">
                    {line.panelItemLine}
                  </span>
                </>
              )
            )}
            *
          </div>
        </div>
      )}

      <div
        className={` ${
          excessReductionDetails ? "quote-card-excess" : "quote-card"
        }`}
      >
        <div className="quote-header">
          <input
            id="companyName"
            label="companyName"
            type="text"
            placeholder="e.g M50 3YJ"
            className="hiddenInput"
            {...register("companyName", { required: "Required" })}
            errors={errors.companyName}
            watch={watch("companyName")}
          />
          <input
            id="pricePerYear"
            label="pricePerYear"
            type="text"
            placeholder="e.g M50 3YJ"
            className="hiddenInput"
            {...register("pricePerYear", { required: "Required" })}
            errors={errors.pricePerYear}
            watch={watch("pricePerYear")}
          />
          {getSchemeImage(quote.schemeTableId)}
        </div>
        <h1 className="companyStyle">{companyName}</h1>

        {/* Payment Details */}
        <h4 className="marginsQuote margin-y">Monthly Payments</h4>
        {paymentOptions.map((option, optIndex) => (
          <div key={optIndex} className="">
            {option.paymentOptionName ===
              "Finance - Deposit and 9 Instalments" && (
              <>
                <div className="padding-10 monthly-payments-div">
                  <div className="marginsQuote">
                    <span className="MStleRight gray-text">Deposit</span>
                    <span className="gray-text">£{option.deposit}</span>
                  </div>

                  <div className="marginsQuote">
                    <span className="MStleRight gray-text">9x</span>
                    <span className="gray-text">
                      £{option.installmentAmount}
                    </span>
                  </div>

                  <div className="marginsQuote">
                    <span className="MStleRight gray-text">Total</span>
                    <span className="gray-text">
                      £
                      {option.totalAmountToPayByCustomer.toLocaleString(
                        "en-GB",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )}
                    </span>
                  </div>
                </div>
                <div className="paying-by-finance">
                  Paying by finance will cost you £
                  {quote?.paymentOptions[0]?.serviceCharge.toFixed(2)} more.
                </div>
              </>
            )}

            {option.paymentOptionName === "Payment in Full" && (
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <div className="per-year-class">
                  <img className="" src={Group} alt="" />
                  <p className="navy-text">
                    <span className="">
                      £
                      {option.totalAmountToPayByCustomer.toLocaleString(
                        "en-GB",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </span>{" "}
                    per year.
                  </p>
                </div>
              </div>
            )}
          </div>
        ))}

        {/* Collapsible Section */}
        <div className="collapsible-section">
          {
            <div className="quote-details">
              <div className="quote-detail">
                <span className="gray-text inline-icon">
                  Excess{" "}
                  <img
                    onClick={() =>
                      openExplanationModal("Additional Excesses", quote)
                    }
                    className="info-icon"
                    src={infoIcon}
                  />
                </span>
                <span className="gray-text">
                  {" "}
                  {quote.panelMemberQuoteExcesses
                    .slice(1)
                    .map((excesses, excessesIndex) => (
                      <div
                        className="marginsDQuoteCustom"
                        key={excesses.excessShortName + excesses.excessAmount}
                      >
                        <span>
                          {excesses.excessShortName === "Windscreen Replacement"
                            ? "Windscreen"
                            : excesses.excessShortName}
                        </span>
                        <span>£{excesses.excessAmount}</span>
                      </div>
                    ))}
                </span>
              </div>

              {/* Move Excess Reduction above Uninsured Driver */}

              {panelMemberQuoteFeatures.map(
                (feature, index) =>
                  feature.featureName === "Uninsured Driver" && (
                    <div key={feature.featureName} className="quote-detail">
                      <span className="gray-text">
                        Uninsured Driver{" "}
                        <img
                          onClick={() =>
                            openExplanationModal("Uninsured Driver", quote)
                          }
                          className="info-icon"
                          src={infoIcon}
                        />
                      </span>
                      {feature.insurerIncludesFeature ? (
                        <span className="gray-text">
                          <img src={included_tick} alt="" />
                        </span>
                      ) : (
                        <span className="gray-text">&#10006;</span>
                      )}
                    </div>
                  )
              )}
            </div>
          }

          {/* Action Buttons */}
          {
            <>
              <button
                type="button"
                className="info-button"
                onClick={() => onOpen(quote)}
              >
                Quote Details
              </button>
              <button className="buy-button" onClick={handleBuyClick}>
                Select Quote
              </button>
            </>
          }
        </div>
      </div>
    </div>
  );
};

export default TqPanelCard;
